import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import Admin from './Admin'

const stateToProps = ({ auth }) => ({
  isAdmin: auth && auth.user && auth.user.roles && auth.user.roles.includes('ROLE_API_ADMIN'),
})

const dispatchToProps = {
  goHome: () => replace('/'),
}

export default connect(stateToProps, dispatchToProps)(Admin)



// WEBPACK FOOTER //
// ./src/pages/Admin/Admin.container.js